module.exports = __webpack_public_path__ + "static/media/silicon-farm-thumbnail.ed5a35fe.jpg";